import { isSSR } from 'utils/isSSR';

export function baseUrl() {
	return isSSR() && globalThis.process?.env
		? (globalThis.process.env.SITE_URL ?? 'https://local.sbazar.dev.dszn.cz')
		: globalThis.window.location.origin;
}

export function baseHost() {
	return baseUrl().replace(/^https?:\/\//, '');
}

export function tld() {
	const url = baseUrl();
	return url.match(/[a-z]+\.dszn\.cz$/)?.[0] ?? 'cz';
}

export function isProduction() {
	return tld() === 'cz';
}
